import {
  useGetCustomTemplatesQuery,
  useSaveCustomTemplateMutation,
  useDeleteCustomTemplateMutation,
} from '../../baseApi';

/**
 * Hook to fetch custom templates.
 */
export const useCustomTemplates = (args = {}) => {
  return useGetCustomTemplatesQuery(args, {
    refetchOnMountOrArgChange: true,
  });
};

/**
 * Hook bundle for custom template CRUD mutations.
 */
export const useCustomTemplateOperations = () => {
  const [saveCustomTemplate, { isLoading: saving }] = useSaveCustomTemplateMutation();
  const [deleteCustomTemplate, { isLoading: deleting }] = useDeleteCustomTemplateMutation();

  return {
    saveCustomTemplate,
    deleteCustomTemplate,
    isProcessing: saving || deleting,
  };
};
